// extracted by mini-css-extract-plugin
module.exports = {"root":"EditListingDescriptionPanel_root__2AM3x","form":"EditListingDescriptionPanel_form__30XEQ","title":"EditListingDescriptionPanel_title__2Qkkl"};